import React from 'react';
import styles from './AdDateBetween.module.scss';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';
import {Else, If, Then} from "react-if";

interface IAdDateBetweenProps {
  startDate: number;
  endDate: number;
  startDateText?: any;
  endDateText?: any;
  seperately?: boolean;
}

const AdDateBetween = (props: IAdDateBetweenProps) => (
  <div className={styles.adDateBetween}>
    <DateRangeIcon className={styles.icon}/>
    &nbsp;
    <If condition={props.startDate > 0}>
      <Then>
        {() => <>
          <If condition={props.seperately}>
            <Then>
              <span className={styles.title}>תאריך הגעה:</span>
              &nbsp;
            </Then>
          </If>
          {props.startDateText}
          <span>
            {moment(props.startDate).format('MMM D YYYY')}
          </span>
        </>}
      </Then>
    </If>
    <If condition={(props.startDate > 0) && (props.endDate > 0)}>
      <Then>
        <If condition={props.seperately}>
          <Then>
            <div style={{marginTop: 10}}/>
            <DateRangeIcon className={styles.icon}/>
            &nbsp;
          </Then>
          <Else>{() => <span> - </span>}</Else>
        </If>
      </Then>
    </If>
    <If condition={props.endDate > 0}>
      <Then>
        {() => <>
          <If condition={props.seperately}>
            <Then>
              <span className={styles.title}>תאריך יציאה:</span>
              &nbsp;
            </Then>
          </If>
          {props.endDateText}
          &nbsp;
          <span>
          {moment(props.endDate).format('MMM D YYYY')}
          </span>
        </>}
      </Then>
    </If>
  </div>
);

AdDateBetween.defaultProps = {
  startDate: 0,
  endDate: 0,
  seperately: false,
};
export default AdDateBetween;
